/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './PortfolioGrowthCommentary.scss';

import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Commentary from 'components/shared/Commentary/Commentary';
import { ruleLookupIndexByValuesPGT } from 'services/Commentary';
import { interpolate } from 'services/Template';
import {portfolioGrowthAccountsWithShareClassMessageEnabled, portfolioGrowthCommentaryEnabled} from 'services/FeatureFlags';
import { roundUp } from 'services/Calculation';
import {
  getPortfolioGrowthForGivenRange,
} from 'state/performance/PortfolioGrowthSelectors';
import {isBetweenFromAndToDates, yyyymmdd} from 'services/Dates';
import {getFormattedDateRangeForPortfolioGrowth} from 'state/performance/PortfolioGrowthFilterSelectors';
import Content from 'services/Content';


class PortfolioGrowthCommentary extends React.Component {
  render() {
    const {commentary = {}, growth, metrics, conversionHistory, dateRange} = this.props;


    if (!(commentary && growth && metrics && growth.length > 0)) {
      return <div id="portfolio-growth-commentary"></div>;
    }

    let firstData = growth[0];
    let lastData = growth[Object.keys(growth).length - 1];

    const marketValueChange = lastData.marketValue - firstData.marketValue;
    const netInvestment = roundUp(
      lastData.netInvestment - firstData.netInvestment
    );

    const lookupIndex = ruleLookupIndexByValuesPGT(
      marketValueChange,
      netInvestment,
      metrics.numOfAdditions,
      metrics.numOfDeductions
    );
    let pgtCommentary = [];
    let lookupResult = commentary.rulesToTemplateLookup[lookupIndex];
    if (lookupResult && lookupResult.templateIds) {
      let templateIds = lookupResult.templateIds;

      const templateParams = {
        ...metrics,
        absMarketValueChange: Math.abs(marketValueChange),
        netInvestment: netInvestment,
        absMarketValueChangeMinusNetInvestment: Math.abs(
          marketValueChange - netInvestment
        )
      };

      pgtCommentary = templateIds.map((tmpId) => {
        let template = commentary.templates.find(
          (tmp) => tmp.id === tmpId
        ).template;
        return interpolate(template, templateParams);
      });
    }

    //if portfolio growth chart share class feature flag is enabled and there is conversion history response,
    // and the conversion trade date falls in the date range show share class commentary
    if (portfolioGrowthAccountsWithShareClassMessageEnabled() && conversionHistory.length > 0) {
      const shareClassEligible = conversionHistory.map((conversion) => {
        if (isBetweenFromAndToDates(yyyymmdd(conversion.tradeDate), dateRange.fromDate, dateRange.toDate)) {
          return true;
        }
        return false;
      });
      if (shareClassEligible.some((shareClass) => shareClass === true)) {
        return (
          <div className="portfolio-growth-commentary">
            <Commentary commentary={pgtCommentary}
                        shareClass={Content.shareClassMessage}/>
          </div>
        );
      }
    }

    if (isEmpty(pgtCommentary) || !portfolioGrowthCommentaryEnabled()) {
      pgtCommentary = ['No observations available.'];
    }

    return (
      <div className="portfolio-growth-commentary">
        <Commentary commentary={pgtCommentary} />
      </div>
    );
  }
}

PortfolioGrowthCommentary.propTypes = {
  metrics: PropTypes.object,
  commentary: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    growth: getPortfolioGrowthForGivenRange(state),
    metrics: state.metrics,
    commentary: state.commentary.portfolioGrowth,
    dateRange: getFormattedDateRangeForPortfolioGrowth(state)
  };
};

export default connect(mapStateToProps)(PortfolioGrowthCommentary);
